<!-- mango admin -->
<!-- <div class="pagination" *ngIf="data">
    <nav class="Pager1" aria-label="pagination example">
        <ul class="pagination pagination-circle justify-content-center">
            <li class="page-item" [ngClass]="{'active' : link.active == true, 'disabled': link.url == null}"
                *ngFor="let link of data?.links;trackBy:trackByIndex">
                <a class="page-link" href="javascript:void(0)" (click)="changePG(link)"
                    [innerHTML]="link.label"></a>
            </li>
        </ul>
    </nav>
</div> -->

<!-- new pagination html for radhe exch admin -->
<!-- <div class="row">
  <div class="col-12 col-sm-12 col-md-6"><span class="frleft">Showing 1 to 1 of 1 entries</span></div>
  <div class="col-12 col-sm-12 col-md-6">
    <div class="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
      <button type="button" class="btn btn-blue" id="PrevPage" name="first" disabled="">First</button><button
        type="button" class="btn btn-blue" id="PrevPage" name="prev" disabled="">Prev</button>
      <button class="btn btn-blue active pagewidth" name="page_no" value="1">1</button><button type="button"
        class="btn btn-blue" id="NextPage" name="next" disabled="">Next</button>
      <button type="button" class="btn btn-blue" id="NextPage" name="last" disabled="">Last</button>
    </div>
  </div>
</div> -->

<div class="row" *ngIf="data">
  <div class="col-12 col-sm-12 col-md-6">
    <!-- <span class="frleft">Showing 1 to 1 of 1 entries</span> -->
  </div>
  <div class="col-12 col-sm-12 col-md-6">
    <div class="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
      <button type="button" class="btn btn-blue" id="PrevPage" name="first" [ngClass]="{'active' : link.active == true, 'disabled': link.url == null}"
      *ngFor="let link of data?.links;trackBy:trackByIndex"><a class="page-link" href="javascript:void(0)" (click)="changePG(link)"
      [innerHTML]="link.label"></a></button>
      <!-- <button type="button" class="btn btn-blue" id="PrevPage" name="prev" disabled="">Prev</button> -->
      <!-- <button class="btn btn-blue active pagewidth" name="page_no" value="1">1</button><button type="button" class="btn btn-blue" id="NextPage" name="next" disabled="">Next</button> -->
      <!-- <button type="button" class="btn btn-blue" id="NextPage" name="last" disabled="">Last</button> -->
    </div>
  </div>
</div>